import useSWRMutation from 'swr/mutation';
import aiTutorAPI from '../axiosInstance';
import {ChatPayload, ChatResponse} from './types';

export function sendAiTutorMessageRequest() {
  return useSWRMutation<ChatResponse, Error, string, ChatPayload>(
    `/chat`,
    (url, {arg}) =>
      aiTutorAPI(url, {method: 'post', data: arg})
        .then((response) => response.data)
        .catch((error) => {
          throw error;
        }),
  );
}
